// Single source of truth for the in-article navigation of the
// "Voice Prompting AI" guide.
//
// The sidebar renders these in order and the scroll-spy watches the same ids,
// so adding a section here is all that is needed to wire it into both.
export const ARTICLE_SECTIONS = [
  {
    id: "what-is-voice-prompting",
    label: "What is voice prompting AI?",
  },
  {
    id: "why-it-works",
    label: "Why it works with chatbots",
  },
  {
    id: "how-to-use",
    label: "Using it with ChatGPT, Claude & Gemini",
  },
  {
    id: "why-zero-typing",
    label: "Why not built-in voice typing?",
  },
  {
    id: "strong-prompt",
    label: "Writing a strong spoken prompt",
  },
  {
    id: "common-mistakes",
    label: "Common mistakes to avoid",
  },
  {
    id: "use-cases",
    label: "Across different use cases",
  },
  {
    id: "faqs",
    label: "FAQ",
  },
];

// Offset used by both the scroll-spy and the smooth-scroll target so a section
// never lands underneath the fixed navbar.
export const SCROLL_OFFSET = 120;

// ---------------------------------------------------------------------------
// Type + surface tokens. These mirror the Google Docs article exactly so both
// pages render headings, body copy and cards with identical styling.
// ---------------------------------------------------------------------------

export const H2 =
  "font-jakarta font-bold text-[#0A0D16] text-[28px] sm:text-[36px] md:text-[44px] lg:text-[50px] leading-[1.28] lg:leading-[64px] tracking-[-0.8px]";

// Same heading, held at the 44px step on desktop. Used only by the ChatGPT /
// Claude / Gemini heading, which is long enough to run to three lines at 50px
// inside the 815.58px column and is designed to sit on two.
export const H2_TIGHT =
  "font-jakarta font-bold text-[#0A0D16] text-[28px] sm:text-[36px] md:text-[44px] leading-[1.28] lg:leading-[58px] tracking-[-0.8px]";

// Standard body paragraph.
export const BODY =
  "font-inter text-[16px] font-normal leading-[29.6px] tracking-[0px] text-[#0A0D16B2]";

// Smaller body copy used inside cards, the timeline and the numbered list.
export const BODY_SM =
  "font-jakarta text-[14px] font-normal leading-[24px] tracking-[0px] text-[#0A0D16B2]";

// Card / sub-section title.
export const CARD_TITLE =
  "font-jakarta text-[16.1px] font-bold leading-[26.16px] tracking-[0px] text-[#0A0D16]";

export const GRADIENT_TEXT =
  "inline-block bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] bg-clip-text text-transparent";

export const CARD_SHADOW =
  "0px 10.73px 32.19px -12.88px #173A8C24, 0px 1.07px 2.15px 0px #0A0E190A";

// Inline link inside body copy.
export const INLINE_LINK =
  "text-[#3AB1F6] underline-offset-2 hover:underline";

// Article column width, matching the Google Docs article.
export const ARTICLE_COLUMN = "w-full lg:max-w-[815.58px]";

// Vertical rhythm between a heading and the paragraph under it.
export const STACK_GAP = "mt-[25.76px]";
